import { DivisionActionTypes, DivisionAction } from '../actions/DivisionActions';
import { DivisionDetail } from '../types/api/divisions/DivisionDetail';
import { Nullable } from '../types/custom/Nullable';

export interface DivisionState {
    personDivisions: {
        data: Nullable<readonly DivisionDetail[]>,
        error: unknown,
        loading: boolean
    }
}

const INITIAL_STATE: DivisionState = {
    personDivisions: {
        data: [],
        error: null,
        loading: false
    }
};

export default function(state = INITIAL_STATE, action: DivisionAction): DivisionState {
    switch(action.type) {
        case DivisionActionTypes.FETCH_DIVISIONS:
            return {
                ...state,
                personDivisions: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case DivisionActionTypes.FETCH_DIVISIONS_SUCCESS:
            return {
                ...state,
                personDivisions: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case DivisionActionTypes.FETCH_DIVISIONS_FAILURE:
            return {
                ...state,
                personDivisions: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };
        default:
            return state;
    }
}